function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "1FA9A312-0FFD-43B3-9FB0-9A07F185CCF4");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Webdesign",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Startseite---open",
  transform: "translate(-186.000000, -20.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("g", {
  id: "ui/icons/menu",
  transform: "translate(186.498306, 20.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.5830499,19.862069 L40.5830499,24 L16.3177437,24 L16.3177437,19.862069 L40.5830499,19.862069 Z M10.9756302,1.07090743 L13.9015892,3.99686653 L7.966,9.931 L35.5626421,9.93103448 L35.5626421,14.0689655 L7.966,14.068 L13.9015892,20.0031331 L10.9756302,22.9290922 L0.593,12.52 L0.0160175682,12.0585255 L0.074,11.999 L0.0160175682,11.9414741 L0.593,11.479 L10.9756302,1.07090743 Z M40.5830499,0 L40.5830499,4.13793103 L16.3177437,4.13793103 L16.3177437,0 L40.5830499,0 Z",
  id: "Combined-Shape"
}))));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "24px",
    viewBox: "0 0 42 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.bb1911cd.svg";
export { ForwardRef as ReactComponent };